import apiUrl from '../../../constants';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'srTrackingWeb',
  components: {
    VueElementLoading,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      userDataKey: '',
      userToken: '',
      srTrackingUrl: ''
    }
  },
  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    this.userToken = window.localStorage.getItem('lmUserToken');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    const queryParams = new URLSearchParams({
      token: this.userToken,
      'app-key': '$LAST$Mile%#$',
      'user-id': this.localuserid
    });
    this.srTrackingUrl = `${apiUrl.srTracking_url}rider-tracking?${queryParams.toString()}`;
    
    let TrackerInfo = {
      projectname:"Last Mile",
      type:"Web",
      userid:this.localuserid,
      username:this.localusermailid,
      meta: {
        "event":""
      }
    }
    let result  = this.PageTracker(TrackerInfo);
  },
  methods: {

  }
}


// WEBPACK FOOTER //
// ./src/views/components/srTrackingWeb/srTrackingWeb.component.js